import { render, staticRenderFns } from "./AppOfferCarousel.vue?vue&type=template&id=2d646e52"
import script from "./AppOfferCarousel.vue?vue&type=script&lang=ts"
export * from "./AppOfferCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports